import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import cn from 'classnames';

// Components.
import WelltoryButton from 'components/Welltory/Button';

// Utils.
import { isIOS, isAndroidOS } from 'utils';

// Styles.
import styles from './styles.module.scss';

// Images.
import { ReactComponent as AppStore } from './images/appstore.svg';
import { ReactComponent as GooglePlay } from './images/googleplay.svg';

export default class HeaderStoreLink extends Component {

	constructor() {
		super();

		this.isIOSStatus = isIOS();
		this.isAndroidOSStatus = isAndroidOS();
	}

	onClickGetAppButton = () => {
		this.props.onClickAnaliticsGetAppButton();
	};

	render() {
		const { auth, profile, isBlack } = this.props;

		if (this.isIOSStatus === false && this.isAndroidOSStatus === false) {
			return null;
		}
		if (auth.isAuthenticated === true && (profile.is_ios_user === true || profile.is_android_user === true)) {
			return null;
		}

		let icon;

		if (this.isIOSStatus === true) {
			icon = <AppStore />;
		}

		else if (this.isAndroidOSStatus === true) {
			icon = <GooglePlay />;
		}

		return (
			<div className={styles.headerStoreLinkWrapper}>
				<WelltoryButton
					type="link"
					to="https://welltory.onelink.me/2180424117/2012f77"
					className={cn(styles.headerStoreLink, {
						[styles.black]: isBlack
					})}
					onClick={this.onClickGetAppButton}
				>
					{icon}<span>{I18n.t('Get the App')}</span>
				</WelltoryButton>
			</div>
		);
	}

}
